import React, { Component } from 'react'
import { Row, Col, Button, Tabs, Input, Tag, Form, notification, Modal } from 'antd';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive'
import DesktopMenu from './desktopMenu';
import MobileMenu from './mobileMenu';
let close = '/images/icon/close.svg'
let menu = '/images/icon/menu.svg';
let logo = '/images/icon/logo-colour.svg';
let logoWhite = '/images/icon/logo-white.svg';

class Menu extends Component {
 state = {
    drawerVisible: false,
  }

  contactModal = () => {
    Modal.info({
      title: 'Contact Us',
      content: (
        <div>
          <p>Rivium Westlaan 8</p>
          <p>2909 LD Capelle aan den IJssel</p>
          <p>Nederland</p>
          <p>E-mail: info@unlocQed.nl</p>
          <p>Tel: +316 408 086 54</p>
        </div>
      )
    });
  }

  render() {
    const {authenticated, firebase, current_user, t} = this.props
      return (
        <div style={{height: '5vw', width: '100%', position: "absolute", zIndex: '99'}}>
          <div className="header-menu">
            <MediaQuery minDeviceWidth={769}>
              <DesktopMenu t={t} contact={this.contactModal} authenticated={authenticated} logout={()=>firebase.logout()} logo={this.state.logo} active={this.props.active}/>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={768}>
              <MobileMenu
                t={t}
                contact={this.contactModal}
                authenticated={authenticated}
                logout={()=>firebase.logout()}
                toggleDrawer={()=>this.setState({drawerVisible: !this.state.drawerVisible})}
                drawerVisible={this.state.drawerVisible}
                active={this.props.active}
              />
            </MediaQuery>
          </div>
        </div>
      )
  }
}

export default Menu
